const analyticsCapture = (dataObject) => {
    
     if(dataObject.action === 'Table action button click') {
         console.log('analytics capture: ', dataObject)
         window.PubSub()

     }
}

const structure  = {
        analyticsCapture
}

window.analytics = structure;